import { render, staticRenderFns } from "./CreatePromotionPlan.vue?vue&type=template&id=59523205&scoped=true&"
import script from "./CreatePromotionPlan.vue?vue&type=script&lang=js&"
export * from "./CreatePromotionPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59523205",
  null
  
)

export default component.exports